import React, { useState, forwardRef, useImperativeHandle } from 'react';
import s from './dropdown.module.css';

// eslint-disable-next-line react/display-name
const Dropdown = forwardRef(({ options, value, onChange, placeholder, height }, ref) => {
	const [isOpen, setIsOpen] = useState(false);
	const [lastTimeToggled, setLastTimeToggled] = useState(new Date());

	const toggleModal = (value, priority = false) => {
		const d = new Date();
		if (priority || d - lastTimeToggled > 80) {
			setIsOpen(value);
			setLastTimeToggled(d);
		}
	};

	useImperativeHandle(ref, () => ({
		parentToggleModal(value, priority) {
			toggleModal(value, priority);
		},
	}));

	if (!isOpen) {
		return null;
	}

	return (
		<div className={s.overlay} style={height ? { height } : {}}>
			{options.map(o => (
				<div
					key={o.value}
					className={`${s.itemContainer} ${value === o.value && '!bg-amber-200'}`}
					onClick={() => onChange(o.value)}
				>
					<div className={`${s.item} `}>{o.label}</div>
				</div>
			))}
		</div>
	);
});

export default Dropdown;
